import styled from 'styled-components/macro'

const FilterText = styled.div`
  display: block;
`

export default FilterText
